import { PageId } from '~/shared/constants/pagesConstants'

// Single source of truth for each multiple-choice question's correct option
// key — used both by the question page itself and by the section-complete
// screen that tallies up how many were answered correctly.
export const MULTIPLE_CHOICE_CORRECT_ANSWERS: Partial<Record<PageId, string>> =
  {
    [PageId.STRONGEST_MUSCLE_ANATOMY_V2_1]: 'masseter',
    [PageId.SMALLEST_BONE_ANATOMY_V2_1]: 'ear',
    [PageId.ORGAN_REGENERATES_ANATOMY_V2_1]: 'liver',
    [PageId.POSTURE_INFLUENCE_ANATOMY_V2_1]: 'feet',
  }
